document.addEventListener('DOMContentLoaded', init);
function init() {

    const tabbedMenu = document.querySelector('.wp-block-oodles-oodles-tabbed-menu');
    const parentMenu = document.querySelector('.menu-top-level-categories');
    const items = document.querySelectorAll('.menu-items article');
    const subMenuGroups = document.querySelectorAll('.menu-sub-level-category-buttons');
    const itemGroups = document.querySelectorAll('.parent-term-items');

    tabbedMenu.addEventListener('click', menuActions);
    function menuActions(event) {
        
        if ( event.target.tagName !== 'BUTTON' ) {
            return false;
        }

        if ( event.target.parentElement === parentMenu ) {

            tabbedMenu.dataset.activeParentCategory = event.target.dataset.term;
            tabbedMenu.dataset.activeSubCategory = getSubInitialTerm(event.target.dataset.term);

            const parentButtons = event.target.parentElement.querySelectorAll('button');
            [...parentButtons].forEach( button => {
                if( button === event.target ) {
                    button.classList.add('active');
                } else {
                    button.classList.remove('active');
                }
            });

            processItemGroup();
            processItems();
        }

        if ( event.target.parentElement.classList.contains('menu-sub-level-category-buttons') ) {

            tabbedMenu.dataset.activeSubCategory = event.target.dataset.term;

            const subButtons = event.target.parentElement.querySelectorAll('button');
            [...subButtons].forEach( button => {
                if( button === event.target ) {
                    button.classList.add('active');
                } else {
                    button.classList.remove('active');
                }
            });

            processItems();
        }

        // search the submenu button groups for the active parent term. Add class to show correct sub menu
        [...subMenuGroups].forEach( group => {
            if ( tabbedMenu.dataset.activeParentCategory === group.dataset.termParent ) {
                group.classList.add('active');
            } else {
                group.classList.remove('active');
            }
        });
    }

    function processItemGroup() {
        [...itemGroups].forEach(item => {
            if ( item.dataset.parentTerm === tabbedMenu.dataset.activeParentCategory ) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        });
    }

    function processItems() {

        const subTerm       = tabbedMenu.dataset.activeSubCategory;

        [...items].forEach( item => {
            item.classList.remove('active');
            const itemGroupsArray = item.dataset.groups.split(',');
            console.log(itemGroupsArray);
            if ( itemGroupsArray.includes(subTerm) ) {
                item.classList.add('active');
            }
        });
    }

    function getSubInitialTerm(parentSlug) {
        const subButtons = document.querySelectorAll(`[data-term-parent=${parentSlug}] button`);
        return subButtons[0].dataset.term;
    }
}